<template>
  <span>
    <v-date-picker
        v-if="inline"
        v-model="currentValue"
        :active-picker.sync="picker"
        no-title
    ></v-date-picker>
    <v-menu
        v-else
        v-model="menu"
        :close-on-content-click="!!closeOnContentClick"
        transition="scale-transition"
        offset-y
        min-width="auto"
    >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
          :filled="!!filled"
          v-model="formatted"
          :label="label ? label : $t('label')"
          :prepend-icon="$vuetify.breakpoint.smAndUp ? 'mdi-calendar' : ''"
          readonly
          hide-details
          v-bind="attrs"
          v-on="on"
      ></v-text-field>
    </template>
    <v-date-picker
        v-model="currentValue"
        :active-picker.sync="picker"
    ></v-date-picker>
  </v-menu>
  </span>
</template>

<script>
import moment from 'moment'

export default {
  name: 'DateSelect',
  props: ['value', 'label', 'inline', 'filled', 'closeOnContentClick'],
  data () {
    return {
      currentValue: this.value,
      menu: false,
      picker: null
    }
  },
  watch: {
    currentValue () {
      this.$emit('update:value', this.currentValue)
    },
    value (value) {
      this.currentValue = value
    }
  },
  computed: {
    formatted () {
      return moment(this.currentValue).format('ll')
    }
  }
}
</script>


<i18n>
{
	"en": {
		"label": "Date"
	},
	"es": {
		"label": "Fecha"
	},
	"fr": {
		"label": "Date"
	},
	"it": {
		"label": "Data"
	},
	"pt": {
		"label": "Data"
	},
	"pl": {
		"label": "Data"
	}
}
</i18n>
